import networkService from '../Network/NetworkManager';
const APPURL = require('../Constants/URLConstants');

const uploadImage = async ({files, full_files}) => {
  try {
    const urls = [];

    const response = await networkService.networkCall(
      APPURL.URLPaths.S3signedUploadURL,
      'POST',
      JSON.stringify({files: files}),
    );

    if (!response.error) {
      const all_path_response = response.data.result;

      for (let index = 0; index < all_path_response.length; index++) {
        const path = all_path_response[index];
        const res = await fetch(path?.signedUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': full_files[index].type, // Fixed the header name
          },
          body: full_files[index],
        });

        if (res.status === 200) {
          urls.push(path?.fileUri);
        }
      }
    }

    return urls;
  } catch (error) {
    // console.error('Error:', error)
    // // You might want to handle the error appropriately, e.g., throw it or return a default value
    // throw error
  }
};

export default uploadImage;
